exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "\n.ant-table-tbody .ant-table-row td[data-v-5eaea70a] {\n  padding-top: 10px;\n  padding-bottom: 10px;\n}\n#components-layout-demo-custom-trigger .trigger[data-v-5eaea70a] {\n  font-size: 18px;\n  line-height: 64px;\n  padding: 0 24px;\n  cursor: pointer;\n  -webkit-transition: color .3s;\n  transition: color .3s;\n}\n", ""]);

// exports
